export default __webpack_public_path__ + "static/media/line-items-gray-small.5ad9686c.svg";